// extracted by mini-css-extract-plugin
export default {"sideBar":"profilesidebar_sideBar__s6D64","title":"profilesidebar_title__SlNHH","active":"profilesidebar_active__8ULGj"};